export default __webpack_public_path__ + "static/media/Quiz.1c6d558b.svg";